import { getHRInfo } from "@/services/v1/hr.service";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  error: null,
};

export const fetchHRInfo = createAsyncThunk(
  "humanResource/fetchHRInfo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getHRInfo();
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const humanResourceSlice = createSlice({
  name: "humanResource",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.error = null;
      return state;
    },
    loginFailure: (state, action) => {
      state.error = action.payload;
      return state;
    },
    logout: (state) => {
      state.user = null;
      state.error = null;
      return state;
    },
    // New reducer for updating account details
    updateAccountDetails: (state, action) => {
      // Merge the new account details with existing user data
      state.user = {
        ...state.user,
        ...action.payload
      };
      state.error = null;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHRInfo.fulfilled, (state, action) => {
        state.user = action.payload;
        state.error = null;
        return state;
      })
      .addCase(fetchHRInfo.rejected, (state, action) => {
        state.error = action.payload;
        return state;
      });
  },
});

export const { 
  loginSuccess, 
  loginFailure, 
  logout, 
  updateAccountDetails // Export the new action
} = humanResourceSlice.actions;
export default humanResourceSlice.reducer;